import { ref } from 'vue'

// Preferência local (por navegador) de quais fluxos ficam escondidos em todo
// o dashboard — KPIs/grid/abas (DashboardView.vue) e Minhas Conversas/faixa
// de avatares/Modo Foco (useMyConversations.ts). Controlada pelo select
// "Esconder Fluxo" no header (DashHeader.vue, atrás da permKey
// dashboard.hideFluxo). Mesmo padrão de preferência simples via localStorage
// já usado em useTheme.ts/tolerância/larguras de painel — sem sincronia
// entre abas de propósito (baixo risco de precisar disso pra essa preferência).
const STORAGE_KEY = 'wootdash_hidden_fluxos'

// Fluxo Geral (fluxo_id 1, FLUXO_MAP em useHelpers.ts) sempre vem escondido
// ao carregar a página — não é "só na primeira vez": todo load força o id 1
// pra dentro do conjunto, mesmo que uma sessão anterior tenha persistido `[]`
// (ex.: o agente desmarcou e recarregou). Desmarcar continua funcionando
// normalmente enquanto a aba está aberta (chama setHiddenFluxoIds, filtra a
// tela na hora) — só não sobrevive a um reload.
const ALWAYS_HIDDEN_FLUXO_ID = 1

function loadInitial(): number[] {
  const stored = (() => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY)
      if (!raw) return []
      const parsed = JSON.parse(raw)
      return Array.isArray(parsed) ? parsed.filter((n): n is number => typeof n === 'number') : []
    } catch {
      return []
    }
  })()
  return stored.includes(ALWAYS_HIDDEN_FLUXO_ID) ? stored : [ALWAYS_HIDDEN_FLUXO_ID, ...stored]
}

export const hiddenFluxoIds = ref<number[]>(loadInitial())

export function setHiddenFluxoIds(ids: number[]): void {
  hiddenFluxoIds.value = ids
  try { localStorage.setItem(STORAGE_KEY, JSON.stringify(ids)) } catch { /* modo privado etc. */ }
}

export function isFluxoHidden(fluxoId: number | null | undefined): boolean {
  if (fluxoId == null) return false
  return hiddenFluxoIds.value.includes(fluxoId)
}
